import { editorContentTimeoffViewState } from "../..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateTimeValidityMapTimeoff", function updateTimeValidityMapTimeoff(timeKey: string, isValid: boolean) {
    if (editorContentTimeoffViewState().timeValidityMap) {
        editorContentTimeoffViewState().timeValidityMap.set(timeKey, isValid);
    }
});